import ScheduleFrequency from '@/models/Shared/ScheduleFrequency';

export default class Schedule {
    frequency: ScheduleFrequency;
    startDate: string; // API stores this as date only without time
    endDate: string; // API stores this as date only without time
}